import getLinksFromText from 'helpers/getLinksFromText'

const LETTER_OR_MARK_REGEX = /[\p{Letter}\p{Mark}]/u

const getInnerText = (html: string): string => {
  const div = document.createElement('div')
  div.innerHTML = html
  return (div.textContent?.replace(/[\n]+/g, '') || '').trim()
}

const getIsTranslatableText = (text: string): boolean => {
  if (!text) return false

  const noHtmlText = getInnerText(text)

  if (!noHtmlText) return false

  const linkText = getLinksFromText(noHtmlText)?.[0] || ''

  const isOnlyOneLink = noHtmlText.length === linkText.length

  const hasTranslatableText = LETTER_OR_MARK_REGEX.test(
    noHtmlText.normalize('NFKD'),
  )

  return hasTranslatableText && !isOnlyOneLink
}

export default getIsTranslatableText
